import { useEffect, useState } from "react";
import { getUserTncStatus, TTncStatus } from "../modules/api/tnc";
import AppUser from "../modules/app-user/app-user";

export function useTncGate(userId?: string, isLogged?: boolean) {
  const [shouldShow, setShouldShow] = useState(false);
  const [initialStatus, setInitialStatus] = useState<TTncStatus>(0);
  const [content, setContent] = useState<string>("");
  const [title, setTitle] = useState<string>("Terms and Conditions");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!isLogged || !userId) return;
      setLoading(true);
      try {
        // Wait for token to be available
        const waitForToken = async (attempts = 0): Promise<boolean> => {
          if (!mounted) return false;
          const user = await AppUser.getInfo();
          if (user.aria_token) return true;
          if (attempts >= 10) return false; // Max 10 attempts
          await new Promise(resolve => setTimeout(resolve, 100));
          return waitForToken(attempts + 1);
        };

        const hasToken = await waitForToken();
        if (!hasToken) throw new Error('Authentication token not available');

        const res = await getUserTncStatus(userId);
        const status = (res.data?.status ?? 0) as TTncStatus;
        if (!mounted) return;
        setInitialStatus(status);
        setContent(res.data?.content || "");
        setTitle(res.data?.title || "Terms and Conditions");
        setShouldShow(status === 0 || status === 2);
      } catch {
        if (!mounted) return;
        setInitialStatus(0);
        setContent("An error occurred while fetching the Terms and Conditions.");
        setTitle("Terms and Conditions");
        setShouldShow(true);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [userId, isLogged]);

  return { shouldShow, setShouldShow, initialStatus, loading, content, title };
}
